<template>
  <div>
    <Head title="Agenda" />

    <files-modal ref="modalFiles">
    </files-modal>

    <div class="shadow_box rounded-lg p-6">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">Agenda Profissional</h1>

      <div class="flex flex-wrap max-w-7xl m-auto my-0">
        <div class="mb-5 lg:mb-10 w-full lg:w-5/12 lg:pr-6">

<!--          <date-calendar v-model="dateAppt" />-->
          <date-calendar v-model="dateAppt" @update:modelValue="handleDateChange" />

<!--          <div class="pr-2">-->
<!--            <button class="flex font-roboto font-medium btn-primary uppercase" style="float:right;" @click="loadAppointments()">-->
<!--              <font-awesome-icon icon="fa-calendar-day" class="text-white text-lg mr-2" /><span class="">Carregar Agendamentos</span>-->
<!--            </button>-->
<!--          </div>-->
        </div>

        <div class="mb-10 w-full lg:w-7/12">
          <progress-chart
            :totalMonth="totalMonth"
            :totalDay="totalDay"
            :totalInProgress="totalInProgress"
            :totalCompleted="totalCompleted"
            :totalNotCompleted="totalNotCompleted" />
        </div>
      </div>

      <data-table
        v-if="loadTable"
        v-model:columns="columns"
        :route="'appointments/list-calendar/' + selectedDate + '/' + nextDate"
        no-data-label="Nenhum agendamento cadastrado"
        no-result-label="Nenhum agendamento encontrado"
      >
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-auto gap-4">
            <button
              v-if="row.openRoom && row.type_service !== 'external'"
              class="btn-primary font-normal text-xs px-4 py-2.5"
              @click="openRoom(row)">
                Acessar consulta
            </button>

            <button
              v-if="row.allowReschedule"
              class="btn-primary font-normal text-xs px-4 py-2.5"
              @click="openModalReschedule(row)">
                Reagendar consulta
            </button>

            <button
              v-if="row.allowCancel"
              class="btn bg-white text-red-700 border border-red-700 font-normal text-xs px-4 py-2.5"
              @click="openModalCancel(row)">
                Cancelar consulta
            </button>
          </div>
        </template>

        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-auto gap-4" :class="{'grid-cols-2': row.openRoom && user.role == 2 && user.professional.id == row.professional.id}">
            <button
              v-if="row.openRoom && row.type_service !== 'external'"
              class="btn-primary font-normal text-xs px-4 py-2.5"
              @click="openRoom(row)">
                Acessar consulta
            </button>

            <button
              v-if="row.allowReschedule"
              class="btn-primary font-normal text-xs px-4 py-2.5"
              @click="openModalReschedule(row)">
                Reagendar consulta
            </button>

            <button
              v-if="row.allowCancel"
              class="btn bg-white text-red-700 border border-red-700 font-normal text-xs px-4 py-2.5"
              @click="openModalCancel(row)">
                Cancelar consulta
            </button>
          </div>
        </template>

        <template #table.cell.content.patient_link="{ value, row }">
          <Link
            v-if="row.patient_id"
            :href="'/patients/detail/' + row.patient_id"
            class="btn-primary font-normal text-xs px-4 py-2.5 block">
              Ver paciente
              <font-awesome-icon icon="fa-chevron-right" class="ml-2" />
          </Link>

          <button
            v-if="row.patient_files_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 block w-full mt-3"
            @click="openModalFiles(row.id, 'files')">
              Ver documentos
              <font-awesome-icon icon="fa-file-arrow-up" class="ml-2" />
          </button>

          <button
            v-if="row.patient_description_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 block w-full mt-3"
            @click="openModalFiles(row.id, 'description')">
              Ver Descrições
              <font-awesome-icon icon="fa-clipboard" class="ml-2" />
          </button>
        </template>

        <template #grid.content.body.patient_link="{ value, row }">
          <Link
            v-if="row.patient_id"
            :href="'/patients/detail/' + row.patient_id"
            class="btn-primary font-normal text-xs px-4 py-2.5">
              Ver paciente
              <font-awesome-icon icon="fa-chevron-right" class="ml-2" />
          </Link>

          <button
            v-if="row.patient_files_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 ml-4 mt-3"
            @click="openModalFiles(row.id, 'files')">
              Ver documentos
              <font-awesome-icon icon="fa-file-arrow-up" class="ml-2" />
          </button>

          <button
            v-if="row.patient_description_count != 0"
            class="btn-primary font-normal text-xs px-4 py-2.5 ml-4 mt-3"
            @click="openModalFiles(row.id, 'description')">
              Ver Descrições
              <font-awesome-icon icon="fa-file-arrow-up" class="ml-2" />
          </button>
        </template>

        <template #table.cell.content.date_end="{ value, row }">
          <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
          <template v-else>
            <popover class="mr-8 md:mr-0" placement="bottom-end">
              <template #default>
                <span class="text-primary font-semibold cursor-pointer">
                  {{ value }}
                </span>
              </template>

              <template #dropdown>
                <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                  <div class="grid gap-4 grid-cols-3">
                    <div></div>
                    <div>Entrada</div>
                    <div>Saída</div>
                    <div>Profissional</div>
                    <div>
                      {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                    </div>
                    <div>Paciente</div>
                    <div>
                      {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </popover>
          </template>
        </template>

        <template #table.content.body.date_end="{ value, row }">
          <template v-if="row.type_service != 'telemedicine'">{{ value }}</template>
          <template v-else>
            <popover class="mr-8 md:mr-0" placement="bottom-end">
              <template #default>
                <span class="text-primary font-semibold cursor-pointer">
                  {{ value }}
                </span>
              </template>
              <template #dropdown>
                <div class="p-4 bg-white shadow_box rounded-lg text-xs">
                  <div class="grid gap-4 grid-cols-3">
                    <div></div>
                    <div>Entrada</div>
                    <div>Saída</div>
                    <div>Profissional</div>
                    <div>
                      {{ row.professional_date_join ? row.professional_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.professional_date_out ? row.professional_date_out.substr(10, 6) : '-' }}
                    </div>
                    <div>Paciente</div>
                    <div>
                      {{ row.patient_date_join ? row.patient_date_join.substr(10, 6) : '-' }}
                    </div>
                    <div>
                      {{ row.patient_date_out ? row.patient_date_out.substr(10, 6) : '-' }}
                    </div>
                  </div>
                </div>
              </template>
            </popover>
          </template>
        </template>

      </data-table>
      <modal-reschedule ref="modalReschedule" @confirm="reloadTable"></modal-reschedule>
      <modal-cancel ref="modalCancel" @confirm="reloadTable"></modal-cancel>
    </div>
  </div>
</template>

<script>
import { Head, Link, useForm } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout/Layout'
import LoadingButton from '@/Shared/Components/LoadingButton'
import ModalDelete from '@/Shared/Modal/ModalDelete'
import ModalEdit from '@/Shared/Modal/ModalEdit'
import DataTable from '@/Shared/Components/DataTable'
import SwitchInput from '@/Shared/Fields/SwitchInput'
import TextInput from '@/Shared/Fields/TextInput'
import PasswordInput from '@/Shared/Fields/PasswordInput'
import MaskInput from '@/Shared/Fields/MaskInput'
import DateTimeInput from '@/Shared/Fields/DateTimeInput'

import ProgressChart from '@/Shared/Components/ProgressChart'
import VueSelectInput from '@/Shared/Fields/VueSelectInput'
import { computed, watch } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'
import format from 'date-fns/format'
import ModalReschedule from '@/Shared/Modal/ModalReschedule'
import ModalCancel from '@/Shared/Modal/ModalCancel'
import Popover from '@/Shared/Components/Popover'
import FilesModal from '@/Shared/Modal/FilesModal'
import DateCalendar from '@/Shared/Components/DateCalendar'


export default {
  components: {
    Head,
    Link,
    LoadingButton,
    ModalDelete,
    ModalEdit,
    DataTable,
    SwitchInput,
    TextInput,
    PasswordInput,
    MaskInput,
    DateTimeInput,
    VueSelectInput,
    format,

    ProgressChart,
    ModalReschedule,
    ModalCancel,
    Popover,
    FilesModal,
    watch,
    DateCalendar,
  },
  layout: Layout,
  props: {
    totalDay: 0,
    totalMonth: 0,
    totalCompleted: 0,
    totalNotCompleted: 0,
    totalInProgress: 0,
    dottedDates: {
      type: Array,
      default: [],
    },
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
  computed: {

  },

  mounted() {

    const initialDate = new Date().toISOString().split('T')[0];
    this.handleDateChange(initialDate);

    // const [ day, month, year ] = this.selectedDate.toLocaleDateString().split('/')
    //
    // this.selectedDate =  year + '-' + month + '-' + day
    // let res = new Date(year + '-' + month + '-' + day);
    // res.setDate(res.getDate() + 2);
    //
    // if(res){
    //   const [ dayEnd, monthEnd, yearEnd ] = res.toLocaleDateString().split('/')
    //   this.nextDate =  yearEnd + '-' + monthEnd + '-' + dayEnd
    // }
  },
  data() {

    return {
      specialties: [],
      professionals: [],
      patients: [],
      monthYear: null,
      // selectedDate: new Date(),
      // nextDate: new Date(),
      dateAppt: new Date().getFullYear() + '-' + (new Date().getMonth() + 1).toString().padStart(2, '0'),
      loadTable: true,
      selectedDateFormatted: '',
      selectedMonthFormatted: '',
      selectedDate: new Date().toISOString().split('T')[0],
      nextDate: new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0],

      columns: [
        {
          uniqid: 'patient_name',
          label: 'Paciente',
          field: 'patient_user.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.type_service == 'external' ? row.patient_name : `${row.patient.user.name}`,
        },
        {
          uniqid: 'date_start',
          label: 'Data da Consulta',
          field: 'date_start',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => this.$filters.formatDate(row.date_start),
        },
        {
          uniqid: 'date_end',
          label: 'Horário',
          field: 'date_end',
          visible: true,
          sortable: false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.date_start.substr(10, 6) + ' - ' + row.date_end.substr(10, 6),
        },
        {
          uniqid: 'specialty',
          label: 'Especialidade',
          field: 'specialties.name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.specialty ? row.specialty.name : ''
        },
        {
          uniqid: 'is_return',
          label: 'Retorno',
          visible: this.patient?.b2b === false,
          sortOrder: 'asc',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.is_return ? row.is_return : ''
        },
        {
          uniqid: 'patient_link',
          label: 'Estado de saúde',
          visible: true,
          align: 'center',
          classes: 'px-4 py-3 border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => ''
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          visible: true,
          align: 'center',
          classes: 'px-4 py-3 border-b text-sm',
        },
      ],
    }

  },
  watch: {
    selectedDate(newDate, oldDate) {
      if (newDate !== oldDate) {
        this.reloadTable();
      }
    }
  },
  methods: {
    handleDateChange(newDate) {
      if (!newDate || isNaN(new Date(newDate).getTime())) {
        console.error("Data inválida:", newDate);
        return;
      }
      this.selectedDate = newDate;
      const nextDate = new Date(newDate);
      nextDate.setDate(nextDate.getDate() + 2);
      this.nextDate = nextDate.toISOString().split('T')[0];
      this.reloadTable();
    },
    reloadTable() {
      this.loadTable = false;
      this.$nextTick(() => {
        this.loadTable = true;
      });
    },

    // handleMonthYear({instance, month, year}) {
    //   let monthYear = year + '-' + (month + 1).toString().padStart(2, '0')
    //   this.monthYear = monthYear
    //   this.updateDottedDates(monthYear + '-01', monthYear)
    //   this.reloadTable()
    // },
    // loadAppointments(){
    //
    //   if (this.dateAppt) {
    //     //0000-00-24-01-2025
    //
    //     const [ val1, val2, day, month, year ] = this.dateAppt.split('-')
    //
    //     this.selectedDate =  year + '-' + month + '-' + day
    //     let res = new Date(year + '-' + month + '-' + day);
    //     res.setDate(res.getDate() + 2);
    //
    //
    //     if(res){
    //       const [ dayEnd, monthEnd, yearEnd ] = res.toLocaleDateString().split('/')
    //       this.nextDate =  yearEnd + '-' + monthEnd + '-' + dayEnd
    //     }
    //
    //     this.monthYear = year + '-' + month
    //   }
    //
    //   this.updateTotals(this.selectedDate ? this.selectedDate : null)
    //
    //   this.reloadTable()
    //
    // },

    openModalFiles(appointment_id, filter) {
      this.$refs.modalFiles.openModal(appointment_id, filter)
    },

    // reloadTable() {
    //   this.loadTable = false
    //   setTimeout(() => this.loadTable = true, 10)
    // },
    submitError() {
      this.updateTotals(this.selectedDate ? format(this.selectedDate, 'yyyy-MM-dd') : null)
    },
    updateDottedDates(date, yearMonth) {
      this.$inertia.reload({
        method: 'put',
        only: [
          'flash',
          'dottedDates',
          'totalMonth',
        ],
        data: {
          date: date,
          month: yearMonth,
        },
      })
    },
    updateTotals(date) {
      this.$inertia.reload({
        method: 'put',
        only: [
          'flash',
          'totalDay',
          'totalMonth',
          'dottedDates',
        ],
        data: {
          date: date,
          month: date ? date.substr(0, 7) : (this.monthYear ? this.monthYear : null),
        }
      })
    },
    openRoom(item) {
      this.$inertia.visit(`/patients/detail/${item.patient.id}/${item.id}`)
    },
    openModalReschedule(item) {
      this.$refs.modalReschedule.openModalReschedule(item, `/appointments/reschedule/${item.id}`)
    },
    openModalCancel(item) {
      this.$refs.modalCancel.openModalCancel(item, `/appointments/cancel/${item.id}`)
    },
  },
}
</script>
